import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCamera24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCamera24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 7.5h7A1.5 1.5 0 0 1 14.5 9v6a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 15V9A1.5 1.5 0 0 1 6 7.5M3 9a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v1.764l4.069-2.835a.75.75 0 0 1 1.178.617l-.015 6.974a.75.75 0 0 1-1.18.612L16 13.289V15a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm13.811 3.027 2.924 2.05.01-4.094z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCamera24);
